import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % TESTIMONIALS.length);
    }, 6500);
    return () => clearInterval(t);
  }, []);

  const t = TESTIMONIALS[idx];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-[#FDFBF7] py-28 md:py-40"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <p className="overline">Voices</p>
        <div className="mt-12 min-h-[280px] md:min-h-[260px] flex flex-col items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={idx}
              data-testid={`testimonial-${idx}`}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.7 }}
              className="font-serif-display italic text-2xl md:text-4xl leading-[1.25] text-[#1A1A1A] max-w-3xl"
            >
              &ldquo;{t.quote}&rdquo;
            </motion.blockquote>
          </AnimatePresence>

          <div className="mt-10 flex flex-col items-center gap-2">
            <div className="h-px w-10 bg-[#C5A059]" />
            <p className="font-serif-display text-lg mt-3">{t.author}</p>
            <p className="overline">{t.context}</p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 mt-10">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              data-testid={`testimonial-dot-${i}`}
              onClick={() => setIdx(i)}
              className={`h-1 transition-all duration-500 ${
                i === idx ? "w-10 bg-[#C5A059]" : "w-5 bg-black/15"
              }`}
              aria-label={`Show testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
